// src/pages/SubcodonProfile/hooks/useFileSelection.js
import { useState, useCallback } from "react";

export const useFileSelection = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedSeqType, setSelectedSeqType] = useState("riboseq");
  const [selectedGroup, setSelectedGroup] = useState("all");

  const toggleFile = useCallback((fileId) => {
    setSelectedFiles((prev) => {
      if (prev.includes(fileId)) {
        return prev.filter((id) => id !== fileId);
      } else {
        return [...prev, fileId];
      }
    });
  }, []);

  const toggleAllFiles = useCallback((fileIds, select = true) => {
    if (select) {
      setSelectedFiles((prev) => {
        const newFiles = fileIds.filter((id) => !prev.includes(id));
        return [...prev, ...newFiles];
      });
    } else {
      setSelectedFiles((prev) => prev.filter((id) => !fileIds.includes(id)));
    }
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedFiles([]);
  }, []);

  return {
    selectedFiles,
    selectedSeqType,
    selectedGroup,
    toggleFile,
    toggleAllFiles,
    setSelectedSeqType,
    setSelectedGroup,
    clearSelection,
  };
};
